var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5715 6.04227V4.32799C14.5715 3.87332 14.3908 3.43729 14.0694 3.1158C13.7479 2.79432 13.3118 2.6137 12.8572 2.6137H11.1429M6.85718 18.0423H2.57146C2.1168 18.0423 1.68077 17.8616 1.35928 17.5402C1.03779 17.2187 0.857178 16.7826 0.857178 16.328V4.32799C0.857178 3.87332 1.03779 3.43729 1.35928 3.1158C1.68077 2.79432 2.1168 2.6137 2.57146 2.6137H4.28575M14.5715 14.6137H19.7143M14.5715 18.0423H19.7143M21.4286 9.47084H12.8572C11.9104 9.47084 11.1429 10.2384 11.1429 11.1851V21.4708C11.1429 22.4176 11.9104 23.1851 12.8572 23.1851H21.4286C22.3754 23.1851 23.1429 22.4176 23.1429 21.4708V11.1851C23.1429 10.2384 22.3754 9.47084 21.4286 9.47084ZM11.5715 0.899414H3.85718L4.56003 3.67656C4.60286 3.86244 4.70765 4.02821 4.85721 4.1466C5.00676 4.26499 5.19214 4.32896 5.38289 4.32799H10.0457C10.2365 4.32896 10.4219 4.26499 10.5714 4.1466C10.721 4.02821 10.8258 3.86244 10.8686 3.67656L11.5715 0.899414Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu4);
export default __webpack_public_path__ + "static/media/iconMenu4.2efc1f51407f62b3fea7da873cabdd68.svg";
export { ForwardRef as ReactComponent };